import React, { useState, useContext } from 'react';
import { Formik, Form } from 'formik';
import { useDispatch } from 'react-redux';

import { EditableFieldsContext } from '../context';

import { FieldDisplay } from './utils';

import { useRootSelector } from 'common/features/featuresReducer';
import { RootState } from 'rootStore';
import {
    fundraisingGroupValidator,
    studentNameValidator,
} from 'common/modules/form-validation/validators';
import { FormikTextField } from 'components/fields/FormikTextField';
import { updateUserThunk } from 'common/features/store/duck/home/duck';
import { Family } from 'common/api/crm/models/Family';
import { Btn } from 'components/btn/Btn';

interface FunraisingForFieldProps {
    isEditing: boolean;
    id: string;
}

export const FundRaisingField = (props: FunraisingForFieldProps) => {
    const profile = useRootSelector((state: RootState) => state.store.home.homeDetails?.profile);
    const textSeparator = profile?.studentName && profile?.fundraisingGroup ? ' - ' : '';
    const text = `${profile?.studentName || ''}${textSeparator}${profile?.fundraisingGroup || ''}`;
    return (
        <FieldDisplay
            id={props.id}
            label="Who are you fundraising for?"
            isEditing={props.isEditing}
        >
            {text}
        </FieldDisplay>
    );
};

export const FundRaisingEditComponent = () => {
    const dispatch = useDispatch<any>();
    const profile = useRootSelector((state: RootState) => state.store.home.homeDetails?.profile);
    const [errorExists, setErrorExists] = useState<boolean>(false);
    const { setFieldToEdit } = useContext(EditableFieldsContext);
    const initialValues = {
        studentName: profile?.studentName ?? '',
        fundraisingGroup: profile?.fundraisingGroup ?? '',
    };

    const onSubmit = async (values: { studentName: string; fundraisingGroup: string }) => {
        const payload = {
            ...profile,
            ...values,
        };

        try {
            await updateUserThunk(payload as Family)(dispatch);
            setFieldToEdit('');
        } catch (e) {
            setErrorExists(true);
        }
    };

    return (
        <div className="mt-5">
            <Formik initialValues={initialValues} onSubmit={onSubmit}>
                <Form>
                    <div className="flex flex-col sm:flex-row">
                        <div className="mb-5 sm:mr-5">
                            <FormikTextField
                                name="studentName"
                                label="Full Name"
                                validate={studentNameValidator}
                            />
                        </div>

                        <div className="mb-5">
                            <FormikTextField
                                name="fundraisingGroup"
                                label="Classroom/Group"
                                validate={fundraisingGroupValidator}
                            />
                        </div>
                    </div>
                    {errorExists && (
                        <p className="text-sm mb-3 text-error">
                            Unable to update your information at this time
                        </p>
                    )}
                    <Btn type="submit">Save</Btn>
                </Form>
            </Formik>
        </div>
    );
};
